document.addEventListener('change', function (event) {
  if (!event.target.closest('variant-picker')) return;

  setTimeout(function () {
    var btn = document.querySelector('[ref="addToCartButton"]');
    if (!btn) return;

    btn.scrollIntoView({ behavior: 'smooth', block: 'center' });

    // Flash the button so it's obvious the selection registered
    btn.style.transition = 'opacity 0.15s';
    btn.style.opacity = '0.4';
    setTimeout(function () { btn.style.opacity = '1'; }, 150);
  }, 80);
});